import { Component, ElementRef, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { CommunicationProxyService } from '../../../services/communication-proxy.service';
import { LoginService } from '../../../services/login.service';
import { StringTableService } from '../../../services/string-table.service';
import { PageViewComponent } from '../../page-view/page-view.component';
import { Table, Types } from '../../table/table.component';
import { ClientList } from '../../../communication-structure/client-list';

@Component({
  selector: 'app-super-admin-access',
  templateUrl: './super-admin-access.component.html',
  styleUrls: ['./super-admin-access.component.scss']
})
export class SuperAdminAccessComponent extends PageViewComponent implements OnInit {

  private getAllClientsEndPoint: string;

  public adminAccessPageTitle: string;

  public adminAccessPageDesc: string;

  private nameColumn: string;

  private enterColumn: string;

  private enterBtnStr: string;

  private clientList: ClientList[];

  private applyContainerBorder: boolean;

  public isLoaded: boolean;

  table: Table[][];

  header: Table[];

  @Output() displayHome = new EventEmitter<any>();

  constructor(
    ele: ElementRef,
    remoteProxy: CommunicationProxyService,
    protected loginService: LoginService,
    stringTableService: StringTableService,
    protected router: Router
  ) {
    super(ele, remoteProxy, loginService, stringTableService, router);
    this.loginService.currentUserClientId = this.loginService.adminClientId;
  }

  ngOnInit() {
    this.adminAccessPageTitle = this.stringTableService.getString('userAccountsAdminAccess', 'pageTitle');
    this.adminAccessPageDesc = this.stringTableService.getString('userAccountsAdminAccess', 'pageDesc');
    this.nameColumn = this.stringTableService.getString('userAccountsAdminAccess', 'nameColumn');
    this.enterColumn = this.stringTableService.getString('userAccountsAdminAccess', 'enterColumn');
    this.enterBtnStr = this.stringTableService.getString('labels', 'enter');
    this.getAllClientsEndPoint = this.stringTableService.getEndpoint('GetAllClients');
    this.applyContainerBorder = false;
    this.isLoaded = false;
    this.GetAllClients();
  }

  GetAllClients() {
    this.getDataFromApi(this.getAllClientsEndPoint, {})
      .subscribe(this.handleAllClientData.bind(this),
      this.handleSubscriptionError.bind(this, this.GetAllClients.bind(this), false));
  }

  handleAllClientData(clientListFromApi) {
    this.hideLoader();
    this.table = [];
    this.header = [];
    this.clientList = clientListFromApi.clientList;
    this.populateHeader();
    for (const record of this.clientList) {
      this.populateTableData(record);
    }
    if (this.table.length > 9) {
      this.applyContainerBorder = true;
    }
    this.isLoaded = true;
  }

  populateHeader() {
    this.header = [
      new Table(Types.TEXT, 'table-header', this.nameColumn),
      new Table(Types.TEXT, 'table-header', this.enterColumn)
    ];
  }

  populateTableData(record) {
    this.table.push([
      new Table(Types.TEXT, 'table-data', record.clientName),
      new Table(Types.BUTTON, 'text-only', this.enterBtnStr),
      new Table(Types.HIDDEN_ID, 'table-data', record.clientId)
    ]);
  }

  onTableButtonClicked(event) {
    if (event.buttonClickedTitle === this.enterBtnStr) {
      for (const row of event.tableRow) {
        if (row.type === 6) {
          this.loginService.currentUserClientId = row.title;
          this.displayHome.emit();
        }
      }
    }
  }

}



// WEBPACK FOOTER //
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/training-management/super-admin-access/super-admin-access.component.ts